/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'automation-menu.empty-state.image.alt': 'Ikon for tom automatiseringsliste',
  'automation-menu.empty-state.learn-more.link': 'Få mere at vide om den manuelle udløser',
  'automation-menu.modal.empty.automations.admin.description':
    'Brug den manuelle udløser til at udfylde en menu med valgmuligheder, som alle, eller personer du angiver, kan anvende som automatiseringer med et enkelt klik.',
  'automation-menu.modal.empty.automations.user.description':
    'Administratorerne har endnu ikke konfigureret nogen manuelt udløste automatiseringer.',
  'automation-menu.modal.error.description': 'Dette tager et stykke tid at indlæse. Prøv at genindlæse siden.',
  'automation-menu.modal.error.image.alt': 'Fejlikon',
  'automation-menu.modal.footer.automate-button': 'Automatiser',
  'automation-menu.modal.footer.cancel-button': 'Annuller',
  'automation-menu.modal.footer.get-started-button': 'Opret automatisering',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Ikon for overskrift for automatiseringsmodal',
  'automation-menu.success-state.message': 'Din automatisering er i gang',
  'fabric.linking.access_exists_description': 'Anmod om adgang til at se dette indhold fra {hostname}.',
  'fabric.linking.actions': 'Handlinger',
  'fabric.linking.add_account': 'Tilføj konto',
  'fabric.linking.ai_summarize': 'Opsummer',
  'fabric.linking.ai_summarized': 'Opsummeret af Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Opsummeret af AI',
  'fabric.linking.ai_summarized_info': 'Informationskvaliteten kan variere. <a>Få mere at vide</a>',
  'fabric.linking.ai_summarized_info_short': 'Indholdskvaliteten kan variere',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence arbejder ...',
  'fabric.linking.ai_summary_action': 'Opsummer med AI',
  'fabric.linking.ai_summary_action_description':
    'Opsummer indholdet af dette link ved hjælp af Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Vi kan ikke vise resultaterne af denne oversigt, da det er i strid med <a>Atlassians politik for acceptabel brug</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence kan ikke generere en oversigt lige nu, da der er for meget indhold at opsummere.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) svarer ikke. Prøv igen senere, eller <a>kontrollér status for AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence kunne ikke behandle din anmodning, da dit indhold indeholder links til HIPAA-begrænset indhold.',
  'fabric.linking.assigned_to': 'Tildelt til {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Anvend en automatisering til <b>{name}</b>.{br}De tilgængelige valg styres af Confluence- og områdeadministratorer.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Sideautomatiseringer',
  'fabric.linking.automation-action.icon.label': 'Ikon for automatisering',
  'fabric.linking.automation-action.title': 'Vis automatiseringsregler',
  'fabric.linking.automation-action.tooltip': 'Vælg en automatiseringsregel, der skal køres',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Annuller',
  'fabric.linking.cannot_connect': 'Kan ikke oprette forbindelse. Prøv igen.',
  'fabric.linking.cannot_find_link': 'Kan ikke finde linket',
  'fabric.linking.check_this_link': 'Kontrollér dette link',
  'fabric.linking.click_to_join': 'Tilmeld dig {context}',
  'fabric.linking.click_to_join_description': 'Du er blevet godkendt, så du kan deltage i {context} med det samme.',
  'fabric.linking.close': 'Luk',
  'fabric.linking.connect_account_description':
    'Vi åbner en ny side for at hjælpe dig til at forbinde din {name}-konto',
  'fabric.linking.connect_link_account': 'Forbind til forhåndsvisning',
  'fabric.linking.connect_link_account_card_view': 'Forbind',
  'fabric.linking.connect_link_account_card_view_description':
    'Tilknyt din {context}-konto, hvis du vil se en forhåndsvisning af dette link',
  'fabric.linking.connect_link_account_card_view_name': 'Forbind din {context}-konto',
  'fabric.linking.connect_to': 'Forbind til {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Forbind til {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Tilknyt din {context}-konto for at samarbejde om arbejde på tværs af Atlassian-produkter.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Tilknyt din konto for at samarbejde om arbejde på tværs af Atlassian-produkter.',
  'fabric.linking.continue': 'Fortsæt',
  'fabric.linking.copied_summary_action_description': 'Kopierede oversigt til udklipsholder',
  'fabric.linking.copied_url_to_clipboard': 'Kopieret!',
  'fabric.linking.copy_summary_action': 'Kopiér oversigt',
  'fabric.linking.copy_summary_action_description': 'Kopiér oversigt',
  'fabric.linking.copy_url_to_clipboard': 'Kopiér link',
  'fabric.linking.couldnt_load_link': 'Af en ukendt årsag kunne vi ikke indlæse dette link.',
  'fabric.linking.create_on_absolute': 'Oprettet {context}',
  'fabric.linking.create_on_relative': 'Oprettet: {context}',
  'fabric.linking.created_by': 'Oprettet af {context}',
  'fabric.linking.delete': 'Slet',
  'fabric.linking.direct_access': 'Tilmeld dig nu',
  'fabric.linking.direct_access_description':
    'Dit team bruger {product} til at samarbejde, og du kan begynde at bruge det med det samme!',
  'fabric.linking.direct_access_title': 'Deltag i {product} for at se dette indhold',
  'fabric.linking.download': 'Hent',
  'fabric.linking.download_description': 'Download denne fil til dit lokale lager',
  'fabric.linking.download_file': 'Download fil',
  'fabric.linking.edit': 'Rediger',
  'fabric.linking.follow': 'Følg',
  'fabric.linking.follow_goal': 'Følg mål',
  'fabric.linking.follow_goal_description': 'Følg dette mål for at få meddelelser om opdateringer',
  'fabric.linking.follow_goal_error':
    'Vi stødte på en fejl, mens vi forsøgte at følge målet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.follow_project': 'Følg projektet',
  'fabric.linking.follow_project-galaxia': 'Følg rummet',
  'fabric.linking.follow_project_description': 'Følg for at få meddelelser om dette projekt',
  'fabric.linking.follow_project_description-galaxia': 'Følg for at få meddelelser om dette space',
  'fabric.linking.follow_project_error':
    'Vi stødte på en fejl under forsøget på at følge projektet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.follow_project_error-galaxia':
    'Vi stødte på en fejl under forsøget på at følge rummet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.forbidden_access': 'Du har ikke adgang',
  'fabric.linking.forbidden_description': 'Kontakt din administrator for at anmode om adgang til {hostname}.',
  'fabric.linking.forbidden_title': 'Du har ikke adgang til dette indhold',
  'fabric.linking.generic_error_message': 'Der opstod en fejl',
  'fabric.linking.go_back': 'Gå tilbage',
  'fabric.linking.invalid_permissions': 'Begrænset indhold',
  'fabric.linking.invalid_permissions_description':
    'Anmod om adgang, eller prøv med en anden konto for at se denne forhåndsvisning.',
  'fabric.linking.join_to_view': 'Deltag i {context} for at se denne sag',
  'fabric.linking.join_to_view-issue-term-refresh': 'Deltag i {context} for at se denne sag',
  'fabric.linking.learn_more_about_connecting_account':
    'Få mere at vide om, hvordan du knytter din konto til Atlassian-produkter.',
  'fabric.linking.learn_more_about_smart_links': 'Få mere at vide om intelligente links.',
  'fabric.linking.link_safety_warning_message':
    'Linket {unsafeLinkText} fører dig til et andet websted, <a>actual link here</a>',
  'fabric.linking.loading': 'Indlæser ...',
  'fabric.linking.modified_on_absolute': 'Opdateret {context}',
  'fabric.linking.modified_on_relative': 'Opdateret: {context}',
  'fabric.linking.more_actions': 'Flere handlinger',
  'fabric.linking.no_access_title': 'Deltag i {product} for at se dette indhold',
  'fabric.linking.not_found_description':
    'Siden findes ikke, eller den kan være ændret, efter at linket blev tilføjet.',
  'fabric.linking.not_found_title': 'Vi kan ikke vise dig denne {product}-side',
  'fabric.linking.open_issue_in_jira': 'Åbn sag i Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Åbn sag i Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Åbn link i en ny fane',
  'fabric.linking.owned_by': 'Ejet af {context}',
  'fabric.linking.owned_by_override': 'Af {context}',
  'fabric.linking.pending_request': 'Din anmodning om adgang afventer behandling',
  'fabric.linking.preview_close': 'Luk forhåndsvisning',
  'fabric.linking.preview_description': 'Åbn en forhåndsvisning i fuld skærm af dette link',
  'fabric.linking.preview_improved': 'Åbn forhåndsvisning',
  'fabric.linking.preview_max_size': 'Vis fuld skærm',
  'fabric.linking.preview_min_size': 'Luk fuld skærm',
  'fabric.linking.preview_modal': 'Åbn forhåndsvisningsmodal',
  'fabric.linking.preview_panel': 'Åbn forhåndsvisningspanel',
  'fabric.linking.priority_blocker': 'Blokering',
  'fabric.linking.priority_critical': 'Kritisk',
  'fabric.linking.priority_high': 'Høj',
  'fabric.linking.priority_highest': 'Højeste',
  'fabric.linking.priority_low': 'Lav',
  'fabric.linking.priority_lowest': 'Laveste',
  'fabric.linking.priority_major': 'Væsentlig',
  'fabric.linking.priority_medium': 'Middel',
  'fabric.linking.priority_minor': 'Mindre',
  'fabric.linking.priority_trivial': 'Triviel',
  'fabric.linking.priority_undefined': 'Ikke defineret',
  'fabric.linking.read_time': 'Kan læses på {context} min.',
  'fabric.linking.related': 'Relateret',
  'fabric.linking.related_links_found_in': 'Fundet i',
  'fabric.linking.related_links_includes_links_to': 'Omfatter links til',
  'fabric.linking.related_links_modal_error_description':
    'Kontrollér din forbindelse, eller opdater siden for at prøve igen',
  'fabric.linking.related_links_modal_error_title': 'Vi har problemer med at indlæse relaterede links',
  'fabric.linking.related_links_modal_title': 'Relaterede links',
  'fabric.linking.related_links_modal_unavailable_description':
    'Vi gennemgår løbende og tilføjer relaterede links til opdaterede sider eller andre indholdstyper',
  'fabric.linking.related_links_modal_unavailable_title': 'Vi kunne ikke finde nogen relaterede links',
  'fabric.linking.related_links_not_found': 'Vi fandt ikke nogen links.',
  'fabric.linking.related_links_view_related_links': 'Se relaterede links',
  'fabric.linking.related_links_view_related_urls': 'Vis nylige links',
  'fabric.linking.request_access': 'Anmod om adgang',
  'fabric.linking.request_access_description':
    'Dit team bruger {product} til at samarbejde. Send din administrator en anmodning om adgang.',
  'fabric.linking.request_access_pending': 'Afventer godkendelse',
  'fabric.linking.request_access_pending_description':
    'Din anmodning om adgang til {hostname} afventer administratorens godkendelse.',
  'fabric.linking.request_access_pending_title': 'Afventer adgang til {product}',
  'fabric.linking.request_access_to_view': 'Anmod om adgang til {context} for at se denne sag',
  'fabric.linking.request_access_to_view-issue-term-refresh': 'Anmod om adgang til {context} for at se denne sag',
  'fabric.linking.request_denied': 'Din anmodning om adgang blev afvist',
  'fabric.linking.request_denied_description':
    'Din administrator godkendte ikke din anmodning om at få vist {product}-sider fra {hostname}.',
  'fabric.linking.restricted_link': 'Begrænset link. Prøv en anden konto',
  'fabric.linking.retry': 'Prøv igen',
  'fabric.linking.save': 'Gem',
  'fabric.linking.sent_on_absolute': 'Sendt den {context}',
  'fabric.linking.sent_on_relative': 'Sendt for {context}',
  'fabric.linking.srclink': 'Vis i',
  'fabric.linking.srclinkunknown': 'Vis original',
  'fabric.linking.status_change_load_error': 'Vi kunne ikke indlæse statusser og overførsler',
  'fabric.linking.status_change_permission_error': 'Du har ikke tilladelse til at overføre denne sag.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Du har ikke tilladelse til at overføre denne sag.',
  'fabric.linking.status_change_update_error': 'Vi kunne ikke opdatere statussen',
  'fabric.linking.team_members_count': '{context} medlemmer',
  'fabric.linking.try_again': 'Prøv igen',
  'fabric.linking.try_another_account': 'Prøv en anden konto',
  'fabric.linking.unassigned': 'Ikke tildelt',
  'fabric.linking.unauthorised_account_description':
    "Du forsøger at få vist et link til en privat {context}-side. Vi anbefaler, at du gennemgår URL'en eller kontakter sideejeren.",
  'fabric.linking.unauthorised_account_description_no_provider':
    "Du forsøger at få vist et link til en privat side. Vi anbefaler, at du gennemgår URL'en eller kontakter sideejeren.",
  'fabric.linking.unauthorised_account_name': 'Vi kan ikke vise private sider fra {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'Vi kan ikke vise private sider',
  'fabric.linking.unfollow': 'Ophør med at følge',
  'fabric.linking.unfollow_goal': 'Stop med at følge mål',
  'fabric.linking.unfollow_goal_description': 'Stop med at følge for at stoppe med at modtage meddelelser om dette mål',
  'fabric.linking.unfollow_goal_error':
    'Vi stødte på en fejl, mens vi forsøgte at stoppe med at følge målet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.unfollow_project': 'Stop med at følge projektet',
  'fabric.linking.unfollow_project-galaxia': 'Stop med at følge rummet',
  'fabric.linking.unfollow_project_description': 'Stop med at følge for at stoppe modtagelse af projektmeddelelser',
  'fabric.linking.unfollow_project_description-galaxia':
    'Stop med at følge for at stoppe modtagelse af områdemeddelelser',
  'fabric.linking.unfollow_project_error':
    'Vi stødte på en fejl under forsøget på at stoppe med at følge projektet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.unfollow_project_error-galaxia':
    'Vi stødte på en fejl under forsøget på at stoppe med at følge rummet. Kontrollér din forbindelse, eller opdater siden, og prøv igen.',
  'fabric.linking.unlink_account': 'Fjern link til konto',
  'fabric.linking.updated_by': 'Ændret af {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Vis',
};
